export const components = {
	infoBanner: {
		tipError: {
			title: "We couldn't complete the registration.",
			description: "Review the filled fields or try again in a few minutes.",
		},
	},
};
